import {defineMessages} from "@project/i18n";

export const serviceDetailMessages = defineMessages({
  serviceContentSections: {
    id: "engineering.services.detail.sections",
    defaultMessage: "Service content sections",
    description: "Accessible label for service detail tabs",
  },
  overview: {
    id: "engineering.services.detail.overview",
    defaultMessage: "Overview",
    description: "Overview tab label for service detail",
  },
  overviewActions: {
    id: "engineering.services.detail.overviewActions",
    defaultMessage: "Service overview actions",
    description: "Accessible label for service overview actions",
  },
  selectView: {
    id: "engineering.services.detail.selectView",
    defaultMessage: "Select service view",
    description: "Accessible label for mobile service detail view switcher",
  },
  viewCurrent: {
    id: "engineering.services.detail.viewCurrent",
    defaultMessage: "View: {view}",
    description: "Current mobile service detail section label",
  },
  manageFunctions: {
    id: "engineering.services.detail.functions.manage",
    defaultMessage: "Manage functions",
    description: "Open Service Function assignment manager",
  },
  noAssignedFunctions: {
    id: "engineering.services.detail.functions.empty",
    defaultMessage: "No functions assigned",
    description: "Empty Service Function assignment summary",
  },
  assignFunction: {
    id: "engineering.services.detail.functions.assign",
    defaultMessage: "Assign function",
    description: "Service Function assignment action",
  },
  removeFunction: {
    id: "engineering.services.detail.functions.remove",
    defaultMessage: "Unassign {name} from service",
    description: "Service Function unassignment label",
  },
  remove: {
    id: "engineering.services.detail.functions.removeAction",
    defaultMessage: "Unassign",
    description: "Remove Service Function assignment",
  },
  selectFunction: {
    id: "engineering.services.detail.functions.select",
    defaultMessage: "Service function",
    description: "Service Function picker label",
  },
  alreadyAssigned: {
    id: "engineering.services.detail.functions.alreadyAssigned",
    defaultMessage: "Function already assigned",
    description: "Selected Service Function already assigned",
  },
  doneManagingFunctions: {
    id: "engineering.services.detail.functions.done",
    defaultMessage: "Done",
    description: "Close Service Function manager",
  },
  updatingFunctions: {
    id: "engineering.services.detail.functions.updating",
    defaultMessage: "Updating functions…",
    description: "Service Function mutation progress",
  },
  failedManagingFunctions: {
    id: "engineering.services.detail.functions.manageFailed",
    defaultMessage: "Could not update functions",
    description: "Service Function manager failure",
  },
  assignmentTitle: {
    id: "engineering.services.detail.functions.assignmentTitle",
    defaultMessage: "Assign service function",
    description: "Service Function assignment modal title",
  },
  unassignmentTitle: {
    id: "engineering.services.detail.functions.unassignmentTitle",
    defaultMessage: "Unassign service function",
    description: "Service Function unassignment modal title",
  },
  confirmUnassignment: {
    id: "engineering.services.detail.functions.confirmUnassignment",
    defaultMessage: "Unassign {name} from this service?",
    description: "Confirm removing Service Function assignment",
  },
  cancelAssignment: {
    id: "engineering.services.detail.functions.cancel",
    defaultMessage: "Cancel",
    description: "Dismiss Service Function assignment modal",
  },
  assignedFunction: {
    id: "engineering.services.detail.functions.assigned",
    defaultMessage: "Function assigned",
    description: "Service Function assignment success",
  },
  failedAssignFunction: {
    id: "engineering.services.detail.functions.failedAssign",
    defaultMessage: "Could not assign function",
    description: "Service Function assignment failure",
  },
  removedFunction: {
    id: "engineering.services.detail.functions.removed",
    defaultMessage: "Function unassigned",
    description: "Service Function unassignment success",
  },
  failedRemoveFunction: {
    id: "engineering.services.detail.functions.failedRemove",
    defaultMessage: "Could not unassign function",
    description: "Service Function unassignment failure",
  },
  composition: {
    id: "engineering.services.detail.composition",
    defaultMessage: "Composition",
    description: "Composite Service components tab",
  },
  compositionUnavailable: {
    id: "engineering.services.detail.composition.unavailable",
    defaultMessage: "Composition is available only for composite services.",
    description: "SIMPLE Service direct-route unavailable state",
  },
  componentsUnavailable: {
    id: "engineering.services.detail.composition.componentsUnavailable",
    defaultMessage: "Component details are unavailable.",
    description: "Composite Service missing direct-component projection",
  },
  backToServices: {
    id: "engineering.services.detail.composition.back",
    defaultMessage: "Back to services",
    description: "Return to Services collection from unavailable composition",
  },
  componentKind: {
    id: "engineering.services.detail.composition.kind",
    defaultMessage: "Kind",
    description: "Component Catalog Item kind column",
  },
  componentName: {
    id: "engineering.services.detail.composition.name",
    defaultMessage: "Component",
    description: "Component Catalog Item name/code column",
  },
  componentQuantity: {
    id: "engineering.services.detail.composition.quantity",
    defaultMessage: "Quantity",
    description: "Direct component quantity column",
  },
  componentUnit: {
    id: "engineering.services.detail.composition.unit",
    defaultMessage: "Unit",
    description: "Service unit or Service billing unit column",
  },
  componentState: {
    id: "engineering.services.detail.composition.state",
    defaultMessage: "State",
    description: "Component lifecycle column",
  },
  componentSupply: {
    id: "engineering.services.detail.composition.supply",
    defaultMessage: "Supply",
    description: "Component derived supply status column",
  },
  serviceKind: {
    id: "engineering.services.detail.composition.service",
    defaultMessage: "Service",
    description: "Service component kind",
  },
  missingOfferDescriptionsTitle: {
    id: "engineering.services.detail.missingOfferDescriptions.title",
    defaultMessage: "Incomplete offer descriptions",
    description: "Title shown when a service has fewer than 3 offer descriptions",
  },
  missingOfferDescriptionsDescription: {
    id: "engineering.services.detail.missingOfferDescriptions.description",
    defaultMessage: "Add the missing offer description(s): {languages}.",
    description:
      "Description shown when a service has fewer than 3 offer descriptions. {languages} lists the missing language codes",
  },
});
